// follows the ordering of days in cron expressions
export const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const timeOptions = [
  // 6 AM to 11:00 PM
  ...Array.from({ length: 18 }, (_, i) => i + 6).flatMap((hour) => {
    const period = hour >= 12 ? 'PM' : 'AM';
    const twelveHour =
      hour === 0 ? 12
      : hour > 12 ? hour - 12
      : hour;
    return [`${twelveHour}:00 ${period}`];
  }),
  // Midnight to 5:00 AM
  ...Array.from({ length: 6 }, (_, i) => i).flatMap((hour) => {
    const period = 'AM';
    const twelveHour = hour === 0 ? 12 : hour;
    return [`${twelveHour}:00 ${period}`];
  }),
];

export const dayNamesAbbreviations = [
  { values: new Set(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']), label: 'Weekdays' },
  { values: new Set(['Saturday', 'Sunday']), label: 'Weekends' },
  { values: new Set(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']), label: 'Daily' },
];

export const timezoneList = Intl.supportedValuesOf('timeZone').map((name) => {
  // Get formatted GMT offset for the timezone
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: name,
    timeZoneName: 'shortOffset',
    hour12: false,
  });

  const offset = formatter.format(new Date()).split(' ')[1].replace('GMT', '').trim();

  // Parse the offset into sign and hours/minutes
  const sign = offset.startsWith('-') ? '-' : '+';
  const [hours, minutes = '00'] = offset.replace(/[+-]/, '').split(':');

  // Pad hours with zeros and construct the final string
  const formattedOffset = `${sign}${hours.padStart(2, '0')}:${minutes}` || '00:00';

  return {
    value: name,
    label: `(GMT ${formattedOffset}) ${name}`,
  };
});
